import { z } from "zod/v4-mini";

import { MAX_FILE_SIZE } from "@/models/FileModel.ts";

export const messageDataSchema = z
  .object({
    visibility: z.literal(["practitioners", "all"], {
      error: "form.required",
    }),
    content_text: z.string(),
    attachments: z.array(z.file()),
  })
  .check(
    z.refine(data => data.content_text || data.attachments.length > 0, {
      path: ["content_text"],
    }),
    z.refine(
      files => {
        const accumulatedFileSize = files.attachments.reduce((acc, file) => (file.size ?? 0) + acc, 0);
        return accumulatedFileSize < MAX_FILE_SIZE;
      },
      { path: ["attachments"], error: "form.file.tooBig" },
    ),
  );

export type MessageData = z.infer<typeof messageDataSchema>;
